// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211205/js/" + chunkId + "." + {"44":"0f6e0ac6","225":"d768003d","481":"8d999afc","486":"78e3743e","770":"9e447f17"}[chunkId] + ".0.44351776544615285.chunk.js";
};